import React,{useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/styles';

import { FormControl,FormControlLabel,InputLabel, MenuItem ,Select, Button, Dialog, DialogTitle,DialogContent,DialogActions,TextField, Switch} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import validate from 'validate.js';
import InputMask from "react-input-mask";

const useStyles = makeStyles(theme => ({
    content: {
        minWidth: '260px'
    }, 
    passwordBlock: {
        display: 'flex'
    },
    alert: {
        margin: '5px auto 10px'
    }  
}));

validate.validators.regex = function(value, options, key, attributes) {
    let regExp = new RegExp(options.pattern);
    
    if (!regExp.test(value)) {
      return "^"+options.message;
    }
  };

validate.validators.phone = function(value, options, key, attributes) {
    
    const phone = value&&value.replace(/[^+\d]/g, '');

    if (/^(\+?7|8)?9\d{9}$/.test(phone)===false) {
      return "^"+options.message;
    }
};

const schema = {
    username: {
        presence: true,
        phone: {
          message: '^Введите номер телефона в федеральном формате' 
        }
      },
      staffGuid: {
        presence: true,
        format: {
            pattern: /^[a-f|0-9]{8}-[a-f|0-9]{4}-[a-f|0-9]{4}-[a-f|0-9]{4}-[a-f|0-9]{12}$/,
            message: "^GUID не соответвует формату"
        },
      }
};

const schemaPassword = {
        presence: true,
        regex: {
        pattern: '(?=.*?[0-9])(?=.*?[A-Z])(?=.*?[a-z])',
        message: "Пароль должен содержать цифры и символы в разных регистрах"
        },
        
        length: {
        minimum: 8,
        message: "^Минимальная длина пароля 8 символов"
        }
};

const UserDialog = props => {
    const { open, onClose, init, isEdit, onSaveUserData, roles, userDialogAlert } = props;

    const classes = useStyles();
    
    const [formState, setFormState] = useState({
        isValid: false,
        isTouched: false,
        values: { ...init },
        touched: {},
        errors: {}
    });

    const nameDialog = (isEdit?"Редактирование":"Создание пользователя")

    useEffect(() => {

        const s = !isEdit||(isEdit&&formState.values.cbChangepassword)?{...schema,password:schemaPassword}:schema;
        const errors = validate(formState.values, s);

        setFormState(formState => ({
            ...formState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [formState.values,isEdit]);

    const handleChange = event => {
        
        event.persist();
        setFormState(formState => ({
            ...formState,
            values: {
                ...formState.values,
                [event.target.name]:
                    event.target.type === 'checkbox'
                        ? event.target.checked
                        : event.target.value
            },
            touched: {
                ...formState.touched,
                [event.target.name]: true
            },
            isTouched: true
        }));
    };

    const handleSaveForm = () => {
        const newObj={};
        if (isEdit&&init) {
            newObj['id']=init.id;
        } else {
            newObj['active']=formState.values['active']||false;
            newObj['role']=formState.values['role']||roles[0].id;
        }
        for (var key in formState.touched) {
            newObj[key]=formState.values[key];
        }
          
        onSaveUserData(newObj);
    }

    const hasError = field => formState.touched[field] && formState.errors[field] ? true : false;

    return (
       
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" disableBackdropClick={true}>
            <DialogTitle id="form-dialog-title">{nameDialog}</DialogTitle>
            <DialogContent className={classes.content}>
                <form>
                <InputMask  
                    mask="+7(999)999-99-99"
                    maskchar="_"
                    value={formState.values.username || ''} 
                    onChange={handleChange} 
                    error={hasError('username')}
                    helperText={ hasError('username') ? formState.errors.username[0] : null }
                >
                  <TextField
                    margin='dense'
                    fullWidth
                    label="Номер телефона"
                    type="text"
                    variant="outlined"
                    name="username"
                    />
                </InputMask>

                <div className={classes.passwordBlock}>
                    {isEdit?
                        <FormControlLabel
                            control={
                                <Switch
                                    type='checkbox'
                                    color='primary'
                                    id="cbChangepassword"
                                    name="cbChangepassword"
                                    checked={formState.values.cbChangepassword||false}
                                    onChange={handleChange} 
                                />}
                            label="Сменить пароль"
                        />
                    :null}

                    <TextField
                    margin='dense'
                    label="Пароль"
                    type="password"
                    variant="outlined"
                    name="password"
                    error={hasError('password')}
                    value={formState.values.password || ''}
                    onChange={handleChange}
                    disabled={!formState.values.cbChangepassword&&isEdit}
                    /> 
                </div>
                <TextField
                    fullWidth
                    margin='dense'
                    variant="outlined"
                    id="lastname"
                    label="Фамилия"
                    type="text"
                    name="lastname"
                    error={hasError('lastname')}
                    value={formState.values.lastname || ''}
                    helperText={hasError('lastname') ? formState.errors.lastname[0] : null}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    margin='dense'
                    variant="outlined"
                    id="firstname"
                    label="Имя"
                    type="text"
                    name="firstname"
                    error={hasError('firstname')}
                    value={formState.values.firstname || ''}
                    helperText={hasError('firstname') ? formState.errors.firstname[0] : null}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    margin='dense'
                    variant="outlined"
                    id="middlename"
                    label="Отчество"
                    type="text"
                    name="middlename"
                    error={hasError('middlename')}
                    value={formState.values.middlename || ''}
                    helperText={hasError('middlename') ? formState.errors.middlename[0] : null}
                    onChange={handleChange}
                />
                <TextField
                    fullWidth
                    margin='dense'
                    variant="outlined"
                    id="staffGuid"
                    label="GUID"
                    type="text"
                    name="staffGuid"
                    error={hasError('staffGuid')}
                    value={formState.values.staffGuid || ''}
                    helperText={hasError('staffGuid') ? formState.errors.staffGuid[0] : null}
                    onChange={handleChange}
                />
                <FormControl variant="outlined" fullWidth margin='dense'>
                    <InputLabel id="access-label">Роль</InputLabel>
                        <Select
                        labelId="access-label"
                        id="role"
                        name="role"
                        value={formState.values.role || roles[0].id}
                        onChange={handleChange}
                        label="Роль"
                        >
                            {roles.map((value,index) => (
                                <MenuItem key={'role_'+value.id} value={value.id}>{value.name}</MenuItem>
                            ))}
                        </Select>
                </FormControl>
                <FormControlLabel
                    control={
                        <Switch
                            type='checkbox'
                            color='primary'
                            id="active"
                            name="active"
                            checked={Boolean(formState.values.active)||false}
                            onChange={handleChange} 
                        />}
                    label="Активен"
                />
                 </form>    
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='secondary'>
                    Отмена
                </Button>   
                <Button onClick={handleSaveForm} color="primary" disabled={!(formState.isTouched&&formState.isValid)}>
                    Сохранить
                </Button>
                  
            </DialogActions>
            {!Boolean(userDialogAlert) ? null :
                <div className={classes.alert}>
                    <Alert severity="error">{userDialogAlert}</Alert>
                </div>
            }   
        </Dialog>
       

        );
    };
    
    UserDialog.propTypes = {
        open: PropTypes.bool, 
        onClose: PropTypes.func,
        init: PropTypes.object,
        isEdit: PropTypes.bool,
        roles: PropTypes.array,
        onSaveUserData: PropTypes.func,
        userDialogAlert: PropTypes.string,
    };

    export default UserDialog;